import MaterialEditor from "@/components/planning/dialogs/newMaterialOrder/MaterialEditor";
import { initialMaterialOrder, MaterialOrder } from "@/components/planning/Project";
import { Add } from "@mui/icons-material";
import { useQueryClient } from "@tanstack/react-query";
import { dispoCalJobQueryKey } from "./CalendarListView";

type SingleJobMaterialOrder = MaterialOrder & { job: number };

export function DirectMaterialBooking({ job, region, project, date }: { job: number; date: string; region: number; project: number }) {
  const queryClient = useQueryClient();

  return (
    <MaterialEditor
      jobId={job}
      projectId={project}
      saveType="DIRECT"
      invalidate={() => {
        queryClient.invalidateQueries({
          queryKey: dispoCalJobQueryKey(job),
        });
        queryClient.invalidateQueries({ queryKey: ["getJobApp", "" + job] });
      }}
      Opener={({ onClick }) => (
        <div className="directbookingButton" onClick={onClick}>
          <Add fontSize="inherit" />
          <div className="dibutext">hinzufügen</div>
        </div>
      )}
      initialState={{ ...initialMaterialOrder(), job }}
    />
  );
}
